import SpriteSymbol from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-item-up-icon",
  "use": "icon-item-up-icon-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-item-up-icon\">\n<g id=\"icon-item-up-icon_Frame 91\">\n<path id=\"icon-item-up-icon_Vector 1\" d=\"M1.125 7L5.68955 1.38209C5.84963 1.18507 6.15037 1.18507 6.31045 1.38209L10.875 7\" stroke=\"#B3B3B3\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol